import { SInput } from '@setvi/shared/components';
import { Form as FormikForm } from 'formik';
import { NumericFormat } from 'react-number-format';
import { FC } from 'react';

interface SPOFormFieldsProps {
  formik: {
    errors: any;
    values: any;
    touched: any;
    handleChange: any;
    handleBlur: any;
    setFieldValue: any;
    setFieldTouched: any;
  };
}

export const SPOFormFields: FC<SPOFormFieldsProps> = ({
  formik: {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched
  }
}) => (
  <FormikForm>
    <SInput
      newDesign
      id="name"
      name="name"
      type="text"
      label="Product Name"
      placeholder="Enter Product Name"
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.name}
      error={touched.name && !!errors.name}
      helperText={touched.name && errors.name}
      required
      fullWidth
    />
    <SInput
      newDesign
      id="vendorName"
      name="vendorName"
      label="Vendor Name"
      placeholder="Enter Vendor Name"
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.vendorName}
      error={touched.vendorName && !!errors.vendorName}
      helperText={touched.vendorName && errors.vendorName}
      required
      fullWidth
    />
    <SInput
      newDesign
      id="sku"
      name="sku"
      type="text"
      label="SKU"
      placeholder="Enter SKU"
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.sku}
      error={touched.sku && !!errors.sku}
      helperText={touched.sku && errors.sku}
      required
      fullWidth
    />
    <NumericFormat
      customInput={SInput}
      newDesign
      id="price"
      name="price"
      label="Cost"
      placeholder="$0.00"
      value={values.price}
      decimalScale={2}
      fixedDecimalScale
      thousandSeparator=","
      decimalSeparator="."
      prefix="$"
      allowNegative={false}
      onValueChange={({ floatValue }) => {
        setFieldValue('price', floatValue ?? null);
      }}
      onBlur={() => setFieldTouched('price', true)}
      error={touched.price && !!errors.price}
      helperText={touched.price && errors.price}
      required
      fullWidth
    />
  </FormikForm>
);
